import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import { useAnalyzeAudience } from 'client/modules/Analyze/AnalyzeAudienceContext';
import AnalyzeAudienceControls from 'client/modules/Analyze/components/AnalyzeAudienceControls';
import DeliveryEvolutionChart from 'client/modules/Analyze/components/DeliveryEvolutionChart';
import DeliveryFunnelCards from 'client/modules/Analyze/components/DeliveryFunnelCards';
import { useGetDeliveryMetricsQuery } from 'client/modules/Surveys/surveyDeliveryApiSlice';
import ActivityIndicator from 'client/modules/App/components/ActivityIndicator/ActivityIndicator';
import unifiedTabsSx from 'components/tabs/unifiedTabsSx';
import React, { useMemo, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useOutletContext } from 'react-router-dom';

const CHANNELS = ['email', 'web', 'link', 'sms', 'api'];

const messages = defineMessages({
  email: { id: 'analyze.delivery.channel.email', defaultMessage: 'Email' },
  web: { id: 'analyze.delivery.channel.web', defaultMessage: 'Web' },
  link: { id: 'analyze.delivery.channel.link', defaultMessage: 'Link' },
  sms: { id: 'analyze.delivery.channel.sms', defaultMessage: 'SMS' },
  api: { id: 'analyze.delivery.channel.api', defaultMessage: 'API' },
  loadError: {
    id: 'analyze.delivery.loadError',
    defaultMessage: 'Failed to load delivery metrics',
  },
});

function AnalyzeDeliveryPage() {
  const { survey } = useOutletContext();
  const { audienceParams } = useAnalyzeAudience();
  const { formatMessage } = useIntl();
  const [channel, setChannel] = useState('web');

  const params = useMemo(
    () => ({ survey: survey?.id, channel, ...audienceParams }),
    [survey?.id, channel, audienceParams],
  );

  const { data, isFetching, isError } = useGetDeliveryMetricsQuery(params, { skip: !survey?.id });

  if (!survey) {
    return null;
  }

  return (
    <Box>
      <AnalyzeAudienceControls />
      <Tabs
        value={Math.max(0, CHANNELS.indexOf(channel))}
        onChange={(_, idx) => setChannel(CHANNELS[idx])}
        sx={{ mb: 3, ...unifiedTabsSx }}
      >
        {CHANNELS.map(c => (
          <Tab key={c} label={formatMessage(messages[c])} />
        ))}
      </Tabs>
      {isFetching && !data && <ActivityIndicator />}
      {isError && !data && (
        <Typography color="error">{formatMessage(messages.loadError)}</Typography>
      )}
      {data && <DeliveryFunnelCards funnel={data.funnel} secondary={data.secondary} />}
      <DeliveryEvolutionChart
        surveyId={survey.id}
        channel={channel}
        audienceParams={audienceParams}
      />
    </Box>
  );
}

export default AnalyzeDeliveryPage;
